import { Wallet, CalendarCheck, KeyRound, SprayCan, MessageCircleWarning, ShieldCheck, FileText } from "lucide-react";

const policies = [
  {
    icon: Wallet,
    title: "Payment",
    text: "Cash, major debit/credit cards through Square, Venmo, PayPal and Chime. Deposits may be required depending on the job; final payment timing follows your agreement.",
  },
  {
    icon: FileText,
    title: "Quotes & Walkthroughs",
    text: "Many remote quotes are provided from photos and property details. Certain in-person or longer-distance walkthroughs may require a $50 deposit that may be credited toward the job.",
  },
  {
    icon: KeyRound,
    title: "Access",
    text: "You don't always have to be home — key, lockbox, entry code or other access arrangements can be agreed beforehand.",
  },
  {
    icon: SprayCan,
    title: "Supplies",
    text: "We bring standard cleaning chemicals, tools and equipment. Please provide a toilet brush for each bathroom. Specialty or fragrance-free products can be discussed in advance.",
  },
  {
    icon: CalendarCheck,
    title: "Cancellations",
    text: "Once a job or walkthrough is approved and time/travel is committed, agreed charges may still apply if access is unavailable or the appointment is cancelled. See your signed terms for details.",
  },
  {
    icon: MessageCircleWarning,
    title: "If Something Was Missed",
    text: "Contact us — we'll evaluate the concern and work toward a reasonable correction on a case-by-case basis.",
  },
];

export default function Policies() {
  return (
    <section id="policies" className="section bg-[#F8FAFC]">
      <div className="container-ss">
        <div className="max-w-2xl">
          <span className="pill mb-3">Payment & Policies</span>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            Simple, fair policies — so every clean goes <span className="text-[#1E3A8A]">smoothly</span>.
          </h2>
          <p className="text-slate-600 mt-3">
            We keep things straightforward and respectful for every client. Here's what to expect.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {policies.map(({ icon: Icon, title, text }) => (
            <div
              key={title}
              className="ss-card p-6 flex gap-4 items-start"
              data-testid={`policy-${title.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              <span className="h-11 w-11 rounded-2xl bg-[#E0F2FE] text-[#0B1A3F] inline-flex items-center justify-center shrink-0">
                <Icon size={20} />
              </span>
              <div>
                <h3 className="font-display text-lg font-semibold text-slate-900">{title}</h3>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-sm text-slate-500 flex items-center gap-2">
          <ShieldCheck size={16} className="text-emerald-600" />
          Final pricing depends on square footage, rooms, bathrooms, condition, scope, add-ons, frequency and travel.
        </p>
        <p className="mt-3 text-sm text-slate-600 italic">
          Full service agreement and payment terms are reviewed before booking.{" "}
          <a href="/pricing" className="text-[#1E3A8A] font-semibold not-italic hover:underline" data-testid="policies-pricing-link">See pricing &amp; full policies →</a>
        </p>
        <div className="mt-6">
          <a href="#quote" className="btn-primary" data-testid="policies-quote-btn">
            <FileText size={16} /> Request a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}
